import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (publish) {
  const { exec, isRequestSuccessed } = useRequest({
    name: 'GET_PREVIEWS',
    url: '',
  });

  useEffect(() => {
    if (publish) {
      let url = `/api/publish_devs`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publish]);

  return isRequestSuccessed;
});
